import { Link } from 'react-router-dom';
import React, { useEffect, useRef } from 'react';
import { exhibitionImgUrl } from '../../common/urls';

const ExhibitionCard = ({ exhibition }) => {
  const imgRef = useRef(null);

  const _go = (url) => {
    window.open(url);
  };
  useEffect(() => {
    const imgContainer = imgRef.current;

    const resizeObserber = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const newWidth = entry.contentRect.width;
        imgContainer.style.height = `${newWidth}px`;
      }
    });

    resizeObserber.observe(imgContainer);

    return () => {
      resizeObserber.unobserve(imgContainer);
    };
  }, []);

  return (
    <div>
      <div
        onClick={() =>
          _go(`https://shop.aniplustv.com/exhibition/${exhibition.idx}`)
        }
        style={{ cursor: 'pointer' }}
      >
        <div
          className="thumb"
          ref={imgRef}
          style={{
            position: 'relative',
            display: 'block',
            textAlign: 'center',
            overflow: 'hidden',
            maxWidth: 800,
          }}
        >
          <img src={exhibitionImgUrl + exhibition.img} />
        </div>
      </div>

      <div
        className="cont"
        onClick={() =>
          _go(`https://shop.aniplustv.com/exhibition/${exhibition.idx}`)
        }
        style={{ cursor: 'pointer' }}
      >
        <span className="icon">
          <img src={exhibitionImgUrl + exhibition.img} />
        </span>
        <span className="rcont">
          <span className="tit">{exhibition.title}</span>
          <span className="txt">{`${exhibition.title} 기획전`}</span>
        </span>
      </div>
    </div>
  );
};

export default ExhibitionCard;
